import { ACCESS_KEY } from "../constants/StorageConstants";
import { makeObservable, observable, computed, action } from "mobx";

class UserStore {
  token = "";

  constructor() {
    makeObservable(this, {
      token: observable,
      setUserToken: action,
      removeUserToken: action,
      isLoggedIn: computed,
      objectFromToken: computed,
    });

    this.token = localStorage.getItem(ACCESS_KEY);
  }

  get isLoggedIn() {
    return !!this.token;
  }

  setUserToken = async (token) => {
    this.token = token;
    localStorage.setItem(ACCESS_KEY, token);
  };

  removeUserToken = async () => {
    localStorage.removeItem(ACCESS_KEY);
    this.token = null;
  };

  get objectFromToken() {
    return this.token;
  }
}

const userStore = new UserStore();
export default userStore;
